// spinner.component.ts
import { Component } from '@angular/core';
import { LoadingService } from '../services/loading.service';

@Component({
  selector: 'app-spinner',
  template: `
    <div class="overlay" *ngIf="loadingService.isLoading$ | async">
      <!-- <div class="spinner"></div> -->
      <div class="loader"></div>
    </div>

  `,
  styles: [`
   /* HTML: <div class="loader"></div> */
   .overlay {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.3);
      z-index: 9999;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .loader {
      width: 50px;
      aspect-ratio: 1;
      color: #2071A7; /* Changed to your primary color */
      background: currentColor;
      border-radius: 50%;
      position: relative;
    }

  .loader:before {
    content: "";
    position: absolute;
    background:
      radial-gradient(farthest-side at bottom right,#0000 94%,currentColor 96%) 0    0,
      radial-gradient(farthest-side at bottom left ,#0000 94%,currentColor 96%) 100% 0,
      radial-gradient(farthest-side at top    left ,#0000 94%,currentColor 96%) 100% 100%,
      radial-gradient(farthest-side at top    right,#0000 94%,currentColor 96%) 0    100%;
    background-size: 25px 25px;
    background-repeat: no-repeat;
    animation: 
      l39-1 1s infinite,
      l39-2 1s infinite;
  }

  @keyframes l39-1 {
    0%,10%,90%,100% {inset:0}
    40%,60% {inset:-10px}
  }

  @keyframes l39-2 {
    0%,40%  {transform: rotate(0)}
    60%,100%{transform: rotate(90deg)}
  }
  `]
})
export class SpinnerComponent {
  constructor(public loadingService: LoadingService) { }
}

// ==========================================================================


// // spinner.component.ts
// import { Component } from '@angular/core';
// import { LoadingService } from '../services/loading.service';

// @Component({
//   selector: 'app-spinner',
//   template: `
//     <div class="overlay" *ngIf="loadingService.isLoading$ | async">
//       <div class="loader"></div>
//     </div>
//   `,
//   styles: [`
//     /* Full-screen overlay */
//     .overlay {
//       position: fixed;
//       width: 100%;
//       height: 100%;
//       top: 0;
//       left: 0;
//       background: rgba(0, 0, 0, 0.3);
//       z-index: 9999;
//       display: flex;
//       justify-content: center;
//       align-items: center;
//     }

//     /* Loader container for the T shape */
//     .loader {
//       width: 50px;
//       height: 50px;
//       position: relative;
//     }

//     /* Horizontal bar of the T */
//     .loader::before {
//       content: "";
//       position: absolute;
//       top: 0;
//       left: 0;
//       height: 10px;
//       width: 0;
//       background: #2071A7; /* Primary color */
//       animation: draw-horizontal 2s linear infinite;
//     }

//     /* Vertical stem of the T */
//     .loader::after {
//       content: "";
//       position: absolute;
//       top: 10px; /* Start just below the horizontal bar */
//       left: 20px; /* Center the 10px-wide stem in the 50px container */
//       width: 10px;
//       height: 0;
//       background: #2071A7;
//       animation: draw-vertical 2s linear infinite;
//     }

//     /* Keyframes to animate horizontal drawing:
//        - From 0% to 25%: grow from 0 to full width (50px)
//        - 25% to 50%: hold the full width
//        - 50% to 100%: shrink back to 0 */
//     @keyframes draw-horizontal {
//       0% { width: 0; }
//       25% { width: 50px; }
//       50% { width: 50px; }
//       75% { width: 50px; }
//       100% { width: 0; }
//     }

//     /* Keyframes to animate vertical drawing:
//        - 0% to 25%: remain hidden
//        - 25% to 50%: grow from 0 to full height (40px)
//        - 50% to 75%: hold the full height
//        - 75% to 100%: shrink back to 0 */
//     @keyframes draw-vertical {
//       0% { height: 0; }
//       25% { height: 0; }
//       50% { height: 40px; }
//       75% { height: 40px; }
//       100% { height: 0; }
//     }
//   `]
// })
// export class SpinnerComponent {
//   constructor(public loadingService: LoadingService) { }
// }
